import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { useEffect } from "react";

import { Container } from "../../../components/Container/Container";
import { Seo } from "../../../components/Seo/Seo";

export const GeneralErrorPage = () => {
	const error = useRouteError();

	useEffect(() => {
		console.error(error);
	}, [error]);

	return (
		<Container>
			<Seo title="Error" description="Something went wrong, please try again later." />

			<h1 className="mb-5">Oops!</h1>
			<p className="text-base mb-2">Sorry, an unexpected error has occurred.</p>

			{isRouteErrorResponse(error) && (
				<p>
					<i>{error?.statusText || error?.data?.message}</i>
				</p>
			)}
		</Container>
	);
};
